import React from "react";
import { PropTypes } from "prop-types";
import { MrbModal } from "mrb/components/modal";
import { MrbButton } from "mrb/components/button";
import { applicationDefaults } from "common/constants";
import { dateFormatter } from "mrb/common/formatting";
import { defaultTemplate } from "common/hoc";
import { MrbRadioButtons } from "mrb";
import { DeviceSetupFlow, AppBadges, ContentModeControl } from "themes/application/device-settings/components";

function PaymentSuccessModalTemplate({ modalParams, t }) {
    const { params, data = {} } = modalParams;
    let title, description;
    if (data.trialUpgraded) {
        const billingStartDate = dateFormatter.format(data.billingStartDate, {
            format: applicationDefaults.formats.longDate,
        });
        title = t("APPLICATION.PREMIUM.TRIAL.UPGRADE_SUCCESS.TITLE");
        description = t("APPLICATION.PREMIUM.TRIAL.UPGRADE_SUCCESS.DESCRIPTION", {
            startDate: billingStartDate,
            subscriptionPlan: data.subscriptionPlan,
        });
    } else {
        title = t("APPLICATION.PAYMENT.PAYMENT_SUCCESS.TITLE");
        description = t("APPLICATION.PAYMENT.PAYMENT_SUCCESS.SUBTITLE");
    }
    const buttonLabel = t("APPLICATION.PAYMENT.PAYMENT_SUCCESS.CONFIRM_BUTTON", {
        subscriptionPlan: data.subscriptionPlan,
    });
    return (
        <MrbModal
            className="modal__content modal__content--lrg"
            modalParams={modalParams}
            shouldCloseOnOverlayClick={false}
            displayCloseIcon={false}
        >
            <div className="c-device-onboarding c-device-onboarding--modal">
                <div className="modal__header u-type--center">
                    <h2>{title}</h2>
                </div>
                <p className="u-type--center">{description}</p>

                <div className="u-mar--top--med">
                    <DeviceSetupFlow t={t} />
                </div>

                <div className="c-device-onboarding__tile">
                    <p className="c-device-onboarding__label">
                        {t("APPLICATION.DEVICE_SETTINGS.ONBOARDING.APP.TITLE")}
                    </p>
                    <AppBadges t={t} />
                </div>

                {(data.modeSelectStore || data.selectedContentModeOption) && (
                    <div className="c-device-onboarding__tile">
                        {data.modeSelectStore ? (
                            <ContentModeControl
                                modeSelectStore={data.modeSelectStore}
                                onInfoClick={data.onClickContentModeInfo}
                                t={t}
                                portalMenu={false}
                            />
                        ) : (
                            <React.Fragment>
                                <div className="c-device-onboarding__label-row">
                                    <p className="c-device-onboarding__label">
                                        {t("APPLICATION.DEVICE_SETTINGS.ONBOARDING.CONTENT_MODE.TITLE")}
                                    </p>
                                    <button
                                        type="button"
                                        className="c-device-onboarding__info-btn"
                                        onClick={data.onClickContentModeInfo}
                                    >
                                        {t("APPLICATION.USER_SETTINGS.EDIT.FIELDS.CERTIFIED_MODE.INFO_BUTTON")}
                                    </button>
                                </div>
                                <MrbRadioButtons
                                    id="content-mode"
                                    name="content-mode"
                                    options={data.contentModeOptions}
                                    onChange={data.setContentModeOption}
                                    value={data.selectedContentModeOption.value}
                                />
                            </React.Fragment>
                        )}
                    </div>
                )}

                <div className="modal__footer u-mar--top--med">
                    <MrbButton label={buttonLabel} onClick={params.onClickExplorePremium} />
                </div>
            </div>
        </MrbModal>
    );
}

PaymentSuccessModalTemplate.propTypes = {
    modalParams: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(PaymentSuccessModalTemplate);
